import { networkLog } from '../../entities/network-log';
import { networkInterceptorLib } from './lib';

type XMLHttpRequestOpenParams = Parameters<
  typeof XMLHttpRequest.prototype.open
>;
type XMLHttpRequestSendParams = Parameters<
  typeof XMLHttpRequest.prototype.send
>;

// eslint-disable-next-line no-console
const netIntLog = (...args: unknown[]) =>
  console.log('[Network interceptor]:', ...args);

export function initInterceptor() {
  const networkLogs = networkLog.model.useNetworkLogs();

  // eslint-disable-next-line no-global-assign
  XMLHttpRequest = new Proxy(XMLHttpRequest, {
    construct(XMLHttpRequestConstructor) {
      const xhr = new XMLHttpRequestConstructor();
      const netLog = networkLogs.init();

      xhr.open = new Proxy(xhr.open, {
        apply(target, that: XMLHttpRequest, args: XMLHttpRequestOpenParams) {
          const requestData = { method: args[0], url: args[1].toString() };
          networkLogs.setPending(netLog, requestData);
          return target.apply(that, args);
        },
      });

      xhr.send = new Proxy(xhr.send, {
        apply(target, that: XMLHttpRequest, args: XMLHttpRequestSendParams) {
          try {
            networkLogs.appendPendingData(netLog, String(args[0]));
          } catch (e) {
            netIntLog(
              `Network log with id ${netLog.id} is already completed. Could not append data`,
              e,
            );
          }
          return target.apply(that, args);
        },
      });

      xhr.addEventListener('loadend', value => {
        // @ts-expect-error For some reason the return type does not contain necessary data, but actual object does contain
        const responseData = networkInterceptorLib.mapXHREvent(value);
        try {
          networkLogs.complete(netLog, responseData);
        } catch (e) {
          netIntLog(`Network log with id ${netLog.id} is already completed`, e);
        }
      });

      return xhr;
    },
  });
}
